import API from '../apiClient';

export const GetOrganization = (entity) => {
    return new Promise((resolve,reject) => {
      API.get(`/organization/admin/${encodeURIComponent(entity)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          reject(error)
          console.log(error)
        }); 
    });
  };

  export const GetAllOrganizations = () => {
    return new Promise((resolve, reject) => {
      API.get('/organization/')
        .then(response => {
          resolve(response); 
        })
        .catch(error => {
          reject(error);
          console.log(error);
        }); 
    });
};

export const GetOrgSSOConfig = (organizationId) => {
    return API.get(`/organization/${encodeURIComponent(organizationId)}/sso-config`)
        .then((response) => response)
        .catch((error) => {
            console.log(error);
            throw error;
        });
};

export const PutOrgSSOConfig = (organizationId, payload) => {
    return API.put(`/organization/${encodeURIComponent(organizationId)}/sso-config`, payload)
        .then((response) => response)
        .catch((error) => {
            console.log(error);
            throw error;
        });
};

export const DeleteOrganization = (entity) => {
    return new Promise((resolve) => {
        API.post(`/organization/${encodeURIComponent(entity)}`)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            console.log(error)
          });
    })

}


